import { forEach, head, map, join, clone } from 'lodash';
import PT from 'prop-types';

const tsRest = require('ts-rest-client');

export const TicketInfoShape = PT.shape({
    id: PT.number,
    seatName: PT.string,
    priceName: PT.string
});

// REST.Models.SaleQuestionnaireID
export const SaleQuestionnaireIDModelShape = PT.shape({
    FormID: PT.string.isRequired,
    PackageID: PT.number,
    EventID: PT.number,
    EventDateID: PT.number,
    OrderID: PT.number,
    CartID: PT.string,
    OwnerPOSID: PT.number,
    TicketID: PT.number
});

// Va chercher les définitions de questionnaires pour chaque Event. (TblEvenement.SaleQuestionnaires)
// QuestionnaireStates: [ // Where does this come from?
//    {
//        questionnaires: [ {
//            EventID: 123
//    } ] }, ... ]
export function loadAllQuestionnaires(questionnaireStates, sellerUserIdParam) {
    const sellerUserId = sellerUserIdParam !== undefined ? sellerUserIdParam : window.tsapp.user.ui; // This is for supporting legacy tsapp side effect.
    const saleQuestionnaireRequestLoadedReq = [];
    
    forEach(questionnaireStates, function(quest) {
        const ownerPOSID = head(quest.questionnaires).OwnerPOSID;
        const eventID = head(quest.questionnaires).EventID;
        if(ownerPOSID !== 0)
            saleQuestionnaireRequestLoadedReq.push(tsRest.get("pos/" + ownerPOSID + "/selleruser/" + sellerUserId + "/salequestionnaires", { async: false, noCache: true })); // eslint-disable-line
        else 
            saleQuestionnaireRequestLoadedReq.push(tsRest.get("event/" + eventID + "/selleruser/" + sellerUserId + "/salequestionnaires", { async: false, noCache: true })); // eslint-disable-line
    });

    return Promise.all(saleQuestionnaireRequestLoadedReq);
}

export function loadQuestionnaireValues(saleQuestionnaireKit, isInAdmin) {
    const cartFormIDs = map(saleQuestionnaireKit.POSForms.cartForms, "id");
    const orderFormIDs = map(saleQuestionnaireKit.EventForms.orderForms, "id");
    const ticketFormIDs = map(saleQuestionnaireKit.EventForms.ticketForms, "id");
    const ticketIDs = map(saleQuestionnaireKit.TicketInfos, "id"); 

    const requestQueryParams = "cfids=" + join(cartFormIDs, ";")
        + "&ofids=" + join(orderFormIDs, ";")
        + "&tfids=" + join(ticketFormIDs, ";")
        + "&pid=" + saleQuestionnaireKit.PackageID 
        + "&eid=" + saleQuestionnaireKit.EventID
        + "&edid=" + saleQuestionnaireKit.EventDateID
        + "&oid=" + saleQuestionnaireKit.OrderID
        + "&cid=" + saleQuestionnaireKit.CartID
        + "&posid=" + saleQuestionnaireKit.OwnerPOSID
        + "&tids=" + join(ticketIDs, ";");
    
    if(isInAdmin)
        return tsRest.get("/salequestionnaires/values?" + requestQueryParams, { noCache: true });
    else
        return tsRest.get("/sessions/current/salequestionnaires/values?" + requestQueryParams, { noCache: true });
}

export function submitResults(filledFormValues, isInAdmin) {
    if(isInAdmin) 
        return tsRest.post("/salequestionnaires/values", { 
            filledFormValues: map(filledFormValues, function(formValues) { 
                const formVal = clone(formValues); formVal.Values = JSON.stringify(formVal.Values); return formVal; 
            })
        }); 
    else 
        return tsRest.post("/sessions/current/salequestionnaires/values", { 
            filledFormValues: map(filledFormValues, function(formValues) { 
                const formVal = clone(formValues); formVal.Values = JSON.stringify(formVal.Values); return formVal; 
            })
        });
}

export function reloadInfoFromFilledForm(filledForm, isInAdmin) {
    const requestQueryParams = "fid=" + filledForm.FormID
        + "&pid=" + filledForm.PackageID
        + "&eid=" + filledForm.EventID
        + "&edid=" + filledForm.EventDateID
        + "&oid=" + filledForm.OrderID
        + "&cid=" + filledForm.CartID
        + "&posid=" + filledForm.OwnerPOSID
        + "&tid=" + filledForm.TicketID;
    
    if(isInAdmin) 
        return tsRest.get("/salequestionnaires/defaultfilledvalues?" + requestQueryParams, { noCache: true });
    else
        return tsRest.get("/sessions/current/salequestionnaires/defaultfilledvalues?" + requestQueryParams, { noCache: true });
}
